import { CMB } from './types';

const initialState = {
    mode: '',
    phoneValue: '',
    isPhoneValid: false,
    consent: false,
    consentId: '',
    informationId: '',
    dateValue: '',
    timeRange: '',
    isFormValid: false,
    isFormSubmitted: false,
    countdownRemaining: 10
};

const ACTION_HANDLERS = {
    [CMB.SAVE_MODE]: (action) => ({
        mode: action.data.mode
    }),
    [CMB.SAVE_PHONE]: (action) => ({
        phoneValue: action.data.phone,
        isPhoneValid: action.data.isPhoneValid
    }),
    [CMB.SAVE_DATE]: (action) => ({
        dateValue: action.data.date,
        timeRange: action.data.timeRange
    }),
    [CMB.SAVE_CONSENT]: (action) => ({
        consent: action.data.isChecked,
        consentId: action.data.consentId,
        informationId: action.data.informationId
    }),
    [CMB.SAVE_VALIDATION_STATE]: (action) => ({
        isFormValid: action.data.isFormValid
    }),
    [CMB.SAVE_SUBMITTED_STATE]: () => ({
        isFormSubmitted: true
    }),
    [CMB.SAVE_COUNTDOWN_REMAINING]: (action) => ({
        countdownRemaining: action.data.remaining
    }),
    [CMB.RESET]: () => ({
        initialState
    })
};

const reducer = (state = initialState, action = { type: null }) => {
    const actionHandler = ACTION_HANDLERS[action.type];
    if (actionHandler) {
        return {
            ...state,
            ...actionHandler(action)
        };
    } else {
        return state;
    }
};

export default reducer;
